<template>
  <div class="body">
      <Headtow  @sou="sou"></Headtow>
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>产品库</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 左侧 -->
        <div class="w-products">
          <ul id="products-content"  v-loading="loading">
              <li v-for="(item, index) in list" :key="item.id">
                <router-link :to="{path:'/CompanyAbout',query: {id: item.id}}">
                  <div class="products-content-left products-content-left-bj" :style="{'background-image': 'url('+item.imageLogos+')'}" >

                      <!-- <img :src="item.imageLogos" alt="" lazy style="object-fit: cover;margin: 0 auto;"> -->
                  </div>
                  <div class="products-content-center">
                      <p class="products-content-center-title">{{item.title}}</p>
                      <p class="products-content-center-jianjie ov2">{{item.content}}</p>
                      <p class="products-content-center-bq">所属行业：{{item.zyhy}}</p>
                      <p class="products-content-center-gsmc  ov1">{{item.address}}</p>
                  </div>
                  <div class="products-content-right">
                    <div class="h-30"></div>
                     <el-button>进入企业</el-button>
                  </div>
                  <div class="clear"></div>
                </router-link>
               </li>
          </ul>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination>
          </div>
        </div>
        <!-- 左侧结束 -->
        <!-- 右侧开始 -->
         <div id="products-right">
             <p class="products-right-title">专家推荐</p>
             <ul class="products-right-ul">
               <li class="ov1" v-for="(item, index) in left" :key="item.id">
                 <router-link  :to="{path:'/ProductsCont',query: {id: item.id}}">
                    {{item.title}}
                </router-link>
               </li>

             </ul>
         </div>
        <!-- 右侧结束 -->
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      list:[],
      page:1,
      total:0,
      info:[],
      activeName: 'first',
      ptzc:'',
      tabPosition:'1',
      left:{},
      keywords:'',
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
     'Foot': foot,

  },
  mounted () {
    this.keywords = this.$route.query.keyword
    console.log(this.keywords);
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Products/Qiyelist",{'page':this.page,'keyword':this.keywords}).then(res => {
          console.log(res);
          that.list= res.list.data;
          this.total = res.list.total
          that.left = res.left;
          this.loading = false
        });
    },
    sou(){
      this.keywords = this.$route.query.keyword
      console.log(this.keywords);
      this.recordapi();
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Qiyelist.vue